import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import ModalInc from '../../../../../shared-ui/ModalInc';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { getPartnerGuid, hasAuthourity } from '../../../../../lib/access.es6';
import { ClaimActionEnum } from '../../../lib/enum';
import { PARTNERS_REQUIRING_CLAIM_REJECTION_REASON } from '../../../../../routes/PartnersEnum';

const DecisionPending = (props) => {
  const [toggleLoading, setToggleLoading] = React.useState('btn1')
  const [showRejectModal, setShowRejectModal] = React.useState(false)
  const [rejectionReason, setRejectionReason] = React.useState('')
  const classes = useStyle();

  const requiresRejectionReason =
    PARTNERS_REQUIRING_CLAIM_REJECTION_REASON.indexOf(getPartnerGuid()) !== -1

  const handleApproveClaim = () => {
    setToggleLoading('btn1')
    props.submitClaimAction({
      claim_action: ClaimActionEnum.approve,
      claim_guid: props.claim.guid,
    })
  }

  const rejectClaim = (body) => {
    setToggleLoading('btn2')
    props.submitClaimAction({
      claim_action: ClaimActionEnum.reject,
      claim_guid: props.claim.guid,
      body
    })
  }

  const handleRejectClaim = () => {
    if (requiresRejectionReason) {
      setShowRejectModal(true)
      return
    }
    rejectClaim(undefined)
  }

  const closeRejectModal = () => {
    setShowRejectModal(false)
    setRejectionReason('')
  }

  const submitRejection = () => {
    rejectClaim({ rejection_reason: rejectionReason.trim() })
    closeRejectModal()
  }

  return (
    <section className={classes.ClaimActionButtons}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ButtonInc onClick={handleApproveClaim} hasPermision={hasAuthourity('UPDATE_CLAIM')} loading={props.loading && toggleLoading ==='btn1'} variant="contained" style={{ width: "221px", height: "55px", float: "left", marginRight: "20px" }}>Approve Claim</ButtonInc>
          <ButtonInc onClick={handleRejectClaim} hasPermision={hasAuthourity('UPDATE_CLAIM')} loading={props.loading && toggleLoading ==='btn2'} variant="contained" style={{ width: "221px", height: "55px", background: "#8F191C" }}>Reject Claim</ButtonInc>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <p style={{color: 'red'}}>{props.error ? props.error.message : ''}</p>
        </Grid>
      </Grid>

      <ModalInc
        modalTitle="Rejection Reason"
        subTitle="Give the reason this claim is being rejected"
        open={showRejectModal}
        onClose={closeRejectModal}
        fullWidth
      >
        <ValidatorForm onSubmit={submitRejection}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='rejectionReason'
                id="rejectionReason"
                label="Rejection Reason"
                value={rejectionReason}
                onChange={e => setRejectionReason(e.target.value)}
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                validators={['required', 'trim']}
                errorMessages={['Please enter the rejection reason', 'Please enter the rejection reason']}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} style={{ textAlign: 'center' }}>
              <ButtonInc
                size="large"
                type="button"
                variant="contained"
                onClick={closeRejectModal}
                style={{ width: "221px", height: "55px", background: "#FBA92D", marginTop: '3%' }}
              >Cancel</ButtonInc>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <ButtonInc
                size="large"
                type="submit"
                variant="contained"
                disabled={!rejectionReason.trim()}
                style={{ width: "221px", height: "55px", background: "#8F191C", marginTop: '3%' }}
              >Reject Claim</ButtonInc>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ModalInc>
    </section>
  )
}

export default DecisionPending
